import './HeaderBD.css';
import React, { useEffect, useState } from 'react';
import bdGriffin from '../img/bd-griffin.png';
import bdGriffinWhite from '../img/bd-griffin-white.png';
import { LanguageNames } from '../interfaces/Interfaces';

interface HeadingProps {
    lang: string | null,
    setLang: React.Dispatch<React.SetStateAction<string | null>>
    displayName: string,
    userExisted: "progressiveProfiling" | "profileEdit" | "addApplication" | undefined,
    countryURL: string,
    appId: string | null,
    hideLanguageSelector: boolean
}

const languageValues: LanguageNames = {
    "en-US": 'English (United States)',
    "fr-CA": "Français (Canada)"
}

const HeaderBD = (props: HeadingProps) => {
    const [appData, setAppData] = useState<any>(null);
    
    useEffect(() => {
        if (props.appId !== null && props.appId !== undefined)
            getApplicationData(props.appId);                       
    }, [props.appId])

    useEffect(() => {
        console.log("hide Language Selector: "+props.hideLanguageSelector);
        if (props.hideLanguageSelector && props.hideLanguageSelector !== undefined) {
            hideLanguageDropdown();
        }
    }, [props.hideLanguageSelector])
    
    const hideLanguageDropdown = async () => {
        try {
            $('.language').addClass('hide');
            console.log("Language dropdown is now hidden.");
        } catch (error) {
            console.error("Error hiding language dropdown:", error);
        }
    };        
    
    
    const getApplicationData = async (appId: string) => {
        const allAppData = await (await fetch(props.countryURL + 'applications.json')).json();         
       
        setAppData(allAppData[appId]);
    }

    const goToLogout = async () => {
        if (appData === null || appData === undefined) return;

        if (appData?.logoutURL) {
            window.location.href = appData.logoutURL;
        }
    }

    return (

        <header className="transparent">
            <a className="logo" href="index.html"><img src={bdGriffinWhite} alt="BD Griffin" /></a>
            <div>
                <div className="links show">                
                    <a className="language 1 foo" href='#'>
                        <i className="fa fa-flag" aria-hidden="true"></i>
                        {" " + languageValues[props.lang as keyof LanguageNames] + " "}
                        <span className="down">
                            <i className="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                    </a>
                    <span className="pipe">&nbsp;</span>
                    {props.userExisted !== undefined || props.userExisted !== "progressiveProfiling" ?
                        <>
                            <span className='63169921-4f1c-4b94-8a39-37adb73b9256'>Hello</span><span>, {props.displayName}&nbsp;</span>
                            <a onClick={goToLogout} style={{ cursor: "pointer" }}><i className="fa fa-user" aria-hidden="true"></i>
                                <span className="b3715166-3fd3-423e-a309-d3eca4d1a67c">Logout</span></a>
                        </> : <></>}
                </div>
                <div className="languages">
                    <ul className=" no-bull">
                        <>
                            {Object.keys(languageValues).map((key: keyof LanguageNames) => {
                                return (
                                    <li key={key}>
                                        <button className="country-link link-imitation"
                                            onClick={
                                                () => {
                                                    props.setLang(key as string);
                                                    $('.languages').hide();
                                                }}>
                                            {languageValues[key]}
                                        </button>
                                    </li>
                                )
                            })}
                        </>
                    </ul>
                    <a className="close" href='#'>&times;</a>
                </div>
            </div>
        </header>
    )
}

export default HeaderBD
